import * as OBC from "@thatopen/components";
export default async function loadIfcFromUri(uri: string, world: OBC.World, components: OBC.Components) {
    const file = await fetch(
        uri,
    );
    const data = await file.arrayBuffer();
    const buffer = new Uint8Array(data);
    const fragmentIfcLoader = components!.get(OBC.IfcLoader);
    // const fragmentIfcLoaderMap = componentsState!.get(OBC.ifc);
    const model = await fragmentIfcLoader.load(buffer);

    // model. = "example";
    // world.scene.three.add(model);
    return model;
}
